import classNames from 'classnames';
import React from 'react';
import { Col } from '../grid/col/col';
import { Paragraph } from '../text/pararaph/pararaph';
import { SkipLinkItem } from './skip-link-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SKIP_LINK_TARGETS;

(function (SKIP_LINK_TARGETS) {
  SKIP_LINK_TARGETS["PRIMARY_NAVIGATION"] = "primary-navigation";
  SKIP_LINK_TARGETS["MAIN_CONTENT"] = "main-content";
  SKIP_LINK_TARGETS["FOOTER_NAVIGATION"] = "footer-navigation";
})(SKIP_LINK_TARGETS || (SKIP_LINK_TARGETS = {}));

export var SkipLink = function SkipLink(_ref) {
  var skipLinks = _ref.skipLinks,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/_jsxs(Col, {
    className: classNames('d-inline-flex align-items-sm-center gap-200', className),
    children: [/*#__PURE__*/_jsx("div", {
      className: "d-block text-nowrap",
      children: /*#__PURE__*/_jsx(Paragraph, {
        className: "responsive",
        children: label
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "d-flex d-sm-flex flex-column flex-sm-row gap-100 gap-sm-200",
      children: skipLinks === null || skipLinks === void 0 ? void 0 : skipLinks.map(function (_ref2) {
        var skipLink = _ref2.skipLink,
            targetId = _ref2.targetId,
            className = _ref2.className;
        return /*#__PURE__*/_jsx(SkipLinkItem, {
          targetId: targetId,
          className: className,
          children: skipLink
        }, skipLink);
      })
    })]
  });
};